import * as yup from 'yup';
import i18n from 'i18n/config';
import { QuestionTypes } from 'containers/app/helpers/questionTypes';

const ANSWER_LIMIT = Math.pow(10, 10);
// The only schema we have to validate forms is for banded questions
// So non banded questions just have an empty validation object
export const validateForm = (currentSlotId, type, currentSlot) => {
  switch (type) {
    case QuestionTypes.BANDED:
      return yup.object().shape({
        [currentSlotId]: yup
          .mixed()
          .test(
            'isNumber',
            i18n.t('openAnswerQuestion.mustBeNumber'),
            value => {
              if (value === null || value === undefined) {
                return true;
              }
              if (value.includes('e') || value.includes('E')) {
                return false;
              }
              return !isNaN(value);
            }
          )
          .test(
            'isNoBiggerThanLimit',
            i18n.t('openAnswerQuestion.mustBeSmallerThan', {
              limit: ANSWER_LIMIT
            }),
            value => {
              return value < ANSWER_LIMIT;
            }
          )
      });
    case QuestionTypes.UPLOAD:
      let accept_types = currentSlot?.question?.accept_types;
      let errorString = getFileErrorMessage(accept_types);
      return yup.object().shape({
        [currentSlotId]: yup.mixed().test('isFile', errorString, value => {
          if (value === null || value === undefined || Array.isArray(value)) {
            return false;
          }
          return value instanceof File;
        })
      });
    case QuestionTypes.SELECT:
      // SELECT is multiple types in one, if we can select multiple
      // it is a multiselect, and the response will be an array
      // Otherwise it will be a single response
      if (currentSlot?.question?.can_select_multiple) {
        return yup.object().shape({
          [currentSlotId]: yup
            .array()
            .test(
              'isNotEmpty',
              i18n.t('mcQuestion.selectAtLeastOne'),
              value => {
                return value.length > 0;
              }
            )
        });
      }
      return yup.object().shape({
        [currentSlotId]: yup
          .mixed()
          .required('Response is required')
          .test(
            'isNotEmptyArray',
            i18n.t('mcQuestion.selectAtLeastOne'),
            value => {
              // arrays are truthy, so we need to check if it is an array
              if (Array.isArray(value) && value.length === 0) {
                return false;
              }
              return value;
            }
          )
      });
    default:
      break;
  }
};

function getFileErrorMessage(accept_types) {
  let errorMessage = i18n.t('uploadFileQuestion.pleaseUploadFile');
  if (accept_types?.includes('video')) {
    errorMessage = i18n.t('videoQuestion.pleaseRecordVideo');
  }
  return errorMessage;
}
